module.exports = __webpack_public_path__ + "6821e8af70ca4b8cb64a14ce7294a6ae.png";